module.exports = __webpack_public_path__ + "static/media/triangle.8b89e333.svg";